import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Warsztat nie pracuje na częściach klienta", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  id: "CalendarEventOwnPartsSidebarHidden",
  type: "hidden",
  name: "data[CalendarEvent][own_parts]",
  value: "0",
  "data-original-title": "",
  title: ""
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  id: "CalendarEventOwnPartsSidebarHidden",
  type: "hidden",
  name: "data[CalendarEvent][own_parts]",
  value: "0",
  "data-original-title": "",
  title: ""
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "CalendarEventOwnPartsSidebar" }, "Posiadam własne części", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DmSelect = _resolveComponent("DmSelect")!
  const _component_DmInput = _resolveComponent("DmInput")!
  const _component_DmTextarea = _resolveComponent("DmTextarea")!
  const _component_DmButton = _resolveComponent("DmButton")!

  return (_openBlock(), _createElementBlock("form", {
    id: "calendarCreateFormSidebar",
    class: "form-other",
    method: "post",
    action: `/calendars/create/${_ctx.dataMechanicId}?wersja=kroki`
  }, [
    _createVNode(_component_DmSelect, {
      id: "CalendarEventRepairDateSidebar",
      modelValue: _ctx.repairDate,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.repairDate) = $event)),
      label: "Termin wizyty (sugerowany):",
      name: "data[CalendarEvent][repair_date]",
      class: "mt-15",
      placeholder: "Dzień wizyty",
      items: _ctx.repairDates,
      native: ""
    }, null, 8, ["modelValue", "items"]),
    _createElementVNode("input", {
      name: "data[CalendarEvent][repair_date]",
      value: _ctx.repairDate?.key,
      type: "hidden",
      "data-gtm-element": "garage-details-reservation-form-choose-date",
      "data-gtm-value": "sidebar-form",
      native: ""
    }, null, 8, _hoisted_2),
    _createVNode(_component_DmSelect, {
      id: "CalendarEventTimeOfDay2",
      modelValue: _ctx.timeOfDay,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timeOfDay) = $event)),
      name: "data[CalendarEvent][time_of_day]",
      class: "mt-10",
      placeholder: "Godzina wizyty",
      items: _ctx.timesOfDay
    }, null, 8, ["modelValue", "items"]),
    _createElementVNode("input", {
      name: "data[CalendarEvent][time_of_day]",
      value: _ctx.timeOfDay?.key,
      type: "hidden",
      "data-gtm-element": "garage-details-reservation-form-choose-hour",
      "data-gtm-value": "sidebar-form"
    }, null, 8, _hoisted_3),
    _createVNode(_component_DmInput, {
      id: "CalendarEventCar",
      modelValue: _ctx.car,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.car) = $event)),
      label: "Samochód (marka, model, silnik, rocznik):",
      class: "mt-15",
      name: "data[CalendarEvent][car]",
      "data-gtm-element": "garage-details-reservation-form-add-car",
      "data-gtm-value": "sidebar-form",
      placeholder: "np. Audi A5 1.8 TFSI 170KM 2016"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_DmTextarea, {
      id: "CalendarEventDescription",
      modelValue: _ctx.notes,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.notes) = $event)),
      class: "mt-15 mb-5",
      label: "Opis usterki:",
      name: "data[CalendarEvent][description]",
      "min-height": 62,
      "data-gtm-element": "garage-details-reservation-form-add-description",
      "data-gtm-value": "sidebar-form",
      style: {"resize":"vertical"},
      placeholder: "np. Wymiana klocków hamulcowych i diagnostyka kontrolki check engine"
    }, null, 8, ["modelValue"]),
    (!!_ctx.dataNoClientParts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            id: "CalendarEventOwnPartsSidebar",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ownParts) = $event)),
            value: + _ctx.ownParts,
            type: "checkbox",
            name: "data[CalendarEvent][own_parts]",
            "data-gtm-element": "garage-details-reservation-form-own-parts",
            "data-gtm-value": "sidebar-form",
            "data-original-title": "",
            title: ""
          }, null, 8, _hoisted_9), [
            [_vModelCheckbox, _ctx.ownParts]
          ]),
          (!_ctx.ownParts)
            ? (_openBlock(), _createElementBlock("input", _hoisted_10))
            : _createCommentVNode("", true),
          _hoisted_11
        ])),
    _createVNode(_component_DmButton, {
      id: "autobooking-form__submit-button",
      title: "Następny krok",
      type: "submit",
      class: "width-100 mt-15"
    })
  ], 8, _hoisted_1))
}